<template>
  <div>
    <tool-bar title="Submission History"></tool-bar>
    <v-container class="page-container" :class="$mq">
      <template v-if="submissionArray && submissionArray.length">
        <v-flex
          v-for="(submission, index) in submissionArray"
          class="service-log-container"
          :key="index">
          <history-repeatable
            v-on:service-log:deleted="getSubmissionArray"
            :submission="submission">
          </history-repeatable>
        </v-flex>
      </template>
      <template v-else>
        <v-flex class="font-italic">
          No Submissions, click
          <span
            @click="goHome"
            style="cursor: pointer"
            class="secondary--text font-bold">
            here
          </span>
          to return to the dashboard.
        </v-flex>
      </template>
    </v-container>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import Toolbar from '@/components/toolbar';
import BottomNav from '@/components/bottom-nav';
import HistoryRepeatable from '@/components/service-log/history/history-repeatable';

export default {
  name: 'HistoryContainer',
  components: {
    Toolbar,
    HistoryRepeatable,
    BottomNav
  },
  created() {
    this.getSubmissionArray();
  },
  data() {
    return {
      submissionArray: ''
    };
  },
  methods: {
    getSubmissionArray() {
      this.submissionArray = JSON.parse(localStorage.getItem('submission-array'));
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service-log/history-container.vue